export { default } from "./AdminConsoleDistrictAddSchoolModal";
